import { Flow } from "../types";
import { SCREENS } from "../screens";

export const ADD_INFORMATION: Flow = {
  [SCREENS.ADD_INFORMATION]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
